class MusicManager {
    static audio = null

    static create() {
        if (this.audio) {
            return
        }
        this.audio = new Audio('../../music/camera.mp3')

    }

    static play() {
        if (!this.audio) {
            return
        }
        this.audio.play()
    }

    static ended(callback) {
        if (!this.audio) {
            return
        }

        this.audio.addEventListener('ended', () => {
            callback()
        })
    }
}

export {
    MusicManager
}
